import NavBar from './components/NavBar'
import Footer from './components/Footer'
import './App.css';
import Weather from './components/Weather';

function App() {
  return (
   <>
   <NavBar/>
   <Weather/>
   <Footer/>
   </>
  );
}

export default App;
